<template>
  <div>
    <div
      class="loading no-data d-flex flex-column align-items-center justify-content-center"
      v-if="loading"
    >
      <loader />
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center"
      v-else
    >
      <alert v-if="error" :showCta="false">
        <template slot="icon">
          <img
            src="@/assets/images/common/error-outline-white.svg"
            alt="Error Icon"
          />
        </template>
        <template slot="message">
          {{ errorMessage }}
        </template>
      </alert>
      <div
        class="d-flex flex-column align-items-center justify-content-center"
        v-else
      >
        <p>
          You will be automatically redirected to our Drip ONE page in the next
          5 to 6 seconds.
        </p>
        <p>
          If it fails to redirect you can click
          <a :href="redirectionURL">here</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader/'
import Alert from '@/components/common/Alert'
import accountsService from '@/services/accounts'

export default {
  components: {
    Loader,
    Alert
  },
  data() {
    return {
      loading: true,
      errorMessage: '',
      error: false,
      redirectToOrg: true,
      redirectionURL: ''
    }
  },
  mounted() {
    this.$mpTrack('Drip One page mounted')
    const isExporter = this.$store.state.account.account.role === 'exporters'
    const isIndian = this.$store.state.account.country === 'India'

    let utmMedium = 'navbar'

    if (this.$route.query.drip_sign_in) {
      this.redirectToOrg = false
      utmMedium = 'signInWithDrip'
    }

    if (this.$route.query.sidebar) {
      utmMedium = 'sidebar'
    }

    if (isExporter && isIndian) {
      accountsService
        .fetchInsight()
        .then((res) => {
          this.redirectionURL = `${process.env.VUE_APP_DRIP_WEB_HOST}/insights/auth/login?token=${res.data.token}`
          this.redirectionURL += '&utm_source=portal&utm_campaign=release'
          this.redirectionURL += `&portal=${this.redirectToOrg}&utm_medium=${utmMedium}`
          window.location.href = this.redirectionURL
          this.loading = false
        })
        .catch(() => {
          this.errorMessage = 'Something went wrong'
          this.error = true
          this.loading = false
        })
    } else {
      this.errorMessage =
        'Drip One is still in Beta and is not available to everyone yet'
      this.error = true
      this.loading = false
    }
  }
}
</script>
